const funcNav = (() => {
  if (document.querySelector("#jsNav") !== null) {
    if (document.querySelector("#jsNavBtn") !== null) {



      let body = document.querySelector('body');
      let nav = document.getElementById('jsNav');
      let navBtn = document.getElementById('jsNavBtn');


      navBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (navBtn.classList.contains('act') == true) {
          body.classList.remove('hidden');
          nav.classList.remove('act');
          navBtn.classList.remove('act');
          nav.classList.add('none');
          navBtn.classList.add('none');
        } else {
          body.classList.add('hidden');
          nav.classList.remove('none');
          navBtn.classList.remove('none');
          nav.classList.add('act');
          navBtn.classList.add('act');
        }
      });


    }
  }
})();
export default funcNav;